"use strict"

import _ from "lodash"
import angular from "angular"

const FREITAG_COMPANY_ID = "65ea4df972faf5fcae84501f"

angular
  .module("uCountitUiApp")

  .controller("ExportConfigCtrl", function ($rootScope, $scope, ExportConfigSrv) {
    $scope.errorMessage = ""

    $scope.services = {
      options: [{ key: "standard", name: "Standard Export" }],
      active: 0,
    }

    const getDefaultForm = function () {
      return {
        standard: {
          active: false,
          buildHour: 2,
          contents: {
            footfall: true,
            flowmap: true,
            genderage: true,
            heatmapImg: false,
            zonetraffic: true,
          },
          protocol: "sftp",
          sftp: {
            host: "",
            port: 22,
            path: "",
            username: "",
            password: "",
            passwordChange: true,
          },
          ftp: {
            host: "",
            port: 21,
            path: "",
            username: "",
            password: "",
            passwordChange: true,
          },
        },
        freitag: {
          active: false,
          buildHour: 22,
          sftpConfig: {
            host: "",
            port: 22,
            path: "",
            username: "",
            password: "",
            passwordChange: true,
          },
          targetStores: [],
        },
      }
    }

    $scope.submitForm = function () {
      $scope.errorMessage = ""
      return ExportConfigSrv.Config.update({ id: $scope.selectedItem.id }, $scope.form)
        .$promise.then(() => $scope.onApply())
        .catch(() => {
          $scope.errorMessage = "Failed to save the configuration"
        })
    }

    const init = async function (item) {
      $scope.connectionTest = {
        status: "idle",
        message: "",
      }

      const defaultForm = getDefaultForm()

      if (!item) {
        $scope.form = defaultForm
        $scope.originalForm = null
      } else {
        const config = await ExportConfigSrv.Config.get({ id: item._id }).$promise

        $scope.originalForm = _.cloneDeep(config)
        const form = _.merge(defaultForm, config)
        $scope.form = form

        const serviceOptions = [{ key: "standard", name: "Standard Export" }]

        if (
          item._id === FREITAG_COMPANY_ID ||
          $rootScope.globalConfig.brand === "local" ||
          $rootScope.globalConfig.brand === "develop"
        ) {
          serviceOptions.push({ key: "freitag", name: "CT001" })
        }

        let active = 0

        for (let idx = 0; idx < serviceOptions.length; idx++) {
          const key = serviceOptions[idx].key

          if ($scope.form[key]?.active) {
            active = idx
            break
          }
        }

        $scope.services.options = serviceOptions
        $scope.$apply()
        $scope.services.active = active
      }
    }

    $scope.$watch("selectedItem", function (item) {
      init(item)
    })
  })
